//Module used for caching templates
angular.module('templates', []);